import { ValidatorFn } from '@angular/forms';
import { DataTypes } from '../enums/DataType';
export abstract class ControlBase {
  
}
